import React from "react"
import { Container, Row, Col } from 'react-bootstrap';
import { useStaticQuery, graphql } from "gatsby"

// Style
import './OurClients.scss';

import { inViewOptions, containerVariants, delayItemsFromBottom, fadeInFromTop } from '../../Utils/animations';
import { motion } from "framer-motion";
import { InView } from "react-intersection-observer";

const MotionCol = motion(Col);

const Clients = (props) => {

    const data = useStaticQuery(graphql`
        query {
            glstrapi {
                clients(sort: "Sort:asc") {
                  Name
                  Image {
                    url
                    alternativeText
                  }
                  Sort
                }
              }
        }
`);

    const clients = data.glstrapi.clients;

    return (
        <InView {...inViewOptions}>
            {({ ref, inView }) => (
                <motion.section
                    className="client-section"
                    ref={ref}
                    initial="hidden"
                    animate={inView ? "visible" : "hidden"}
                    variants={containerVariants}
                >
                    <Container>
                        <Row>
                            <Col>
                                <motion.div className="clients" variants={fadeInFromTop}>
                                    {props.Title &&
                                        <sm className="sm-content">{props.Title}</sm>
                                    }

                                    {props.Sub_Title &&
                                        <p>{props.Sub_Title}</p>
                                    }
                                </motion.div>
                                <div className="client-info">
                                    {clients.map((item, index) => (
                                        <MotionCol
                                            xl={1}
                                            lg={4}
                                            xs={6}
                                            className="client-list"
                                            custom={index}
                                            variants={delayItemsFromBottom}
                                        >
                                            {item.Image &&
                                                <img src={item.Image.url} alt={`Client Logo- Dacha`} />
                                            }
                                        </MotionCol>
                                    ))}
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </motion.section>
            )}
        </InView>

    )
}
export default Clients